import { render } from "./GymHowItWorks.vue?vue&type=template&id=d68f23ca&scoped=true"
import script from "./GymHowItWorks.vue?vue&type=script&lang=js"
export * from "./GymHowItWorks.vue?vue&type=script&lang=js"

import "./GymHowItWorks.vue?vue&type=style&index=0&id=d68f23ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d68f23ca"]])

export default __exports__